import ReferralCreateBrowse from './ReferralCreateBrowse';

export default ReferralCreateBrowse;
